import React, { useState } from "react";
import { Modal } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  HourglassOutlined,
} from "@ant-design/icons"; // ícones corretos
import styled from "styled-components";

// Estilos
const StatusItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 0.8rem;
`;

const TituloModal = styled.h3`
  font-size: 1.1rem;
  margin-bottom: 1rem;
  color: #003644;
`;

// Componente
export default function InfoModal() {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Ícone de ajuda */}
      <span
        onClick={(e) => {
          e.stopPropagation(); // evita conflitos com dropdowns
          setOpen(true);
        }}
        style={{ marginLeft: 8, cursor: "pointer", display: "inline-flex" }}
      >
        <QuestionCircleOutlined style={{ fontSize: 18, color: "#888" }} />
      </span>

      {/* Modal de explicação */}
      <Modal
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        title={<TituloModal>Significado dos Status</TituloModal>}
      >
        <StatusItem>
          <CheckCircleOutlined style={{ color: "green", fontSize: 18 }} />
          <span>Atendido MC</span>
        </StatusItem>

        <StatusItem>
          <CloseCircleOutlined style={{ color: "red", fontSize: 18 }} />
          <span>Não Atendido</span>
        </StatusItem>

        <StatusItem>
          <HourglassOutlined style={{ color: "orange", fontSize: 18 }} />
          <span>Aguardando</span>
        </StatusItem>
      </Modal>
    </>
  );
}
